"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _immutable = _interopRequireDefault(require("immutable"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UITypeahead = _interopRequireDefault(require("UIComponents/typeahead/UITypeahead"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _utils = require("../utils/utils");

var _langUtils = require("../utils/langUtils");

var _default = _react.default.createClass({
  displayName: "MultiselectDropdownFilter",
  mixins: [_ComponentWithPartials.default, _reactAddonsPureRenderMixin.default],
  propTypes: {
    defaultOption: _react.PropTypes.string.isRequired,
    disableOptions: _react.PropTypes.bool.isRequired,
    filterType: _react.PropTypes.string.isRequired,
    maxSelections: _react.PropTypes.number,
    onGoodFilterChange: _react.PropTypes.func.isRequired,
    selectedFilters: _react.PropTypes.instanceOf(_immutable.default.List).isRequired,
    trackMultiselectSelection: _react.PropTypes.func.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      disableOptions: false
    };
  },
  getOptionText: function getOptionText(filter) {
    return (0, _langUtils.getMultiselectFilterOptionOrTitleText)(this.props.filterType, filter);
  },
  handleFilterRemoval: function handleFilterRemoval(filterToRemove) {
    var _this$props = this.props,
        filterType = _this$props.filterType,
        onGoodFilterChange = _this$props.onGoodFilterChange,
        selectedFilters = _this$props.selectedFilters;
    return onGoodFilterChange((0, _utils.getMultiselectFilterObjAfterRemove)(filterType, selectedFilters, filterToRemove));
  },
  handleFilterSelection: function handleFilterSelection(event) {
    var _this$props2 = this.props,
        filterType = _this$props2.filterType,
        onGoodFilterChange = _this$props2.onGoodFilterChange,
        selectedFilters = _this$props2.selectedFilters,
        trackMultiselectSelection = _this$props2.trackMultiselectSelection;
    var newSelection = event.target.value;
    trackMultiselectSelection(filterType, newSelection);
    return onGoodFilterChange((0, _defineProperty2.default)({}, filterType, selectedFilters.push(newSelection)));
  },
  isBelowMaxSelected: function isBelowMaxSelected(maxSelections, allOptions, selectedFilters) {
    if (maxSelections) {
      return selectedFilters.size < maxSelections;
    }

    return selectedFilters.size < Object.keys(allOptions).length;
  },
  renderDropdown: function renderDropdown(allOptions, selectedFilters, defaultOption, filterType, disableOptions) {
    var options = (0, _utils.getAlphaSortedArrOfTextValPairsForSelect)((0, _utils.getUnselectedOptions)(allOptions, selectedFilters), this.getOptionText).map(function (option) {
      return (0, _extends2.default)({}, option, {
        disabled: disableOptions
      });
    });
    return _react.default.createElement(_UIDropdown.default, {
      buttonClassName: "p-all-0 " + (0, _utils.getMultiselectDropdownClass)(filterType),
      buttonText: this.getOptionText(defaultOption),
      buttonUse: "transparent",
      placement: "bottom right"
    }, _react.default.createElement(_UITypeahead.default, {
      onChange: this.handleFilterSelection,
      options: options
    }));
  },
  renderSelectedFilter: function renderSelectedFilter(filter, index) {
    return _react.default.createElement(_UITag.default, {
      key: index,
      closeable: true,
      onCloseClick: this.partial(this.handleFilterRemoval, filter)
    }, this.getOptionText(filter));
  },
  render: function render() {
    var _this$props3 = this.props,
        defaultOption = _this$props3.defaultOption,
        disableOptions = _this$props3.disableOptions,
        filterType = _this$props3.filterType,
        maxSelections = _this$props3.maxSelections,
        selectedFilters = _this$props3.selectedFilters;
    var allOptions = (0, _utils.getMultiselectDropdownOptions)(filterType);
    return _react.default.createElement("div", {
      className: "dropdown-container"
    }, _react.default.createElement("div", null, _react.default.createElement("span", {
      className: "is--heading-7 m-bottom-1 display-inline-block"
    }, (0, _langUtils.getMultiselectFilterOptionOrTitleText)(filterType, 'fullTitle')), maxSelections && _react.default.createElement(_Small.default, {
      use: "help",
      className: "m-left-1 display-inline-block"
    }, (0, _langUtils.getMultiselectMaxText)(maxSelections))), _react.default.createElement("div", null, selectedFilters.size > 0 && _react.default.createElement(_UIList.default, {
      inline: true
    }, selectedFilters.map(this.renderSelectedFilter))), this.isBelowMaxSelected(maxSelections, allOptions, selectedFilters) ? this.renderDropdown(allOptions, selectedFilters, defaultOption, filterType, disableOptions) : null);
  }
});

exports.default = _default;
module.exports = exports.default;